import { useState } from "react";
import { Translation } from "./types";

interface UseLocaleNavigationReturn {
  localeIndex: number;
  handlePreviousLocale: () => void;
  handleNextLocale: () => void;
}

/**
 * Hook to manage locale navigation state
 */
export const useLocaleNavigation = (translations: Translation[]): UseLocaleNavigationReturn => {
  const [localeIndex, setLocaleIndex] = useState<number>(0);
  const maxIndex = translations.length - 1;

  const handlePreviousLocale = () => {
    setLocaleIndex(prev => Math.max(0, prev - 1));
  };

  const handleNextLocale = () => {
    setLocaleIndex(prev => Math.min(maxIndex, prev + 1));
  };

  return {
    localeIndex,
    handlePreviousLocale,
    handleNextLocale,
  };
};
